// components/RedirectToExternal.js
import { useEffect } from 'react';

const RedirectToExternal = ({ url }) => {
  useEffect(() => {
    window.location.href = url; // Redirects to external URL
  }, [url]);

  return null; // Nothing to render
};

export default RedirectToExternal;